var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowTilted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.891775 9.91337L0.90577 8.72381L7.81921 8.72381L0.47193 1.37653L1.31162 0.536838L8.6589 7.88412L8.6589 0.970678L9.84846 0.956683L9.84846 9.91337L0.891775 9.91337Z",
    fill: "#FC0808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowTilted);
export default __webpack_public_path__ + "static/media/downArrowTilted.3bda762ea8aa97bb913e1df841206bb1.svg";
export { ForwardRef as ReactComponent };